import { render, staticRenderFns } from "./PetBreedSearchFieldResults.vue?vue&type=template&id=5b288000"
import script from "./PetBreedSearchFieldResults.vue?vue&type=script&lang=js"
export * from "./PetBreedSearchFieldResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports